import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";

const GetAllTeacher = async () => {
  let UsersRef = collection(db, "Users");
  let Teachers = [];
  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);

  const q = query(
    UsersRef,
    where("UserType", "==", "teacher"),
    where("IsVerified", "==", 1),
    where("SchoolID", "==", schoolId)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    Teachers.push({
      id: doc.id,
      ...doc.data(),
    });
  });

  return Teachers;
};

export default GetAllTeacher;
